export default __webpack_public_path__ + "static/media/grass.62ce916b.png";